import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import { signinUser } from '../../actions';

function SignIn(props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const submit = (e) => {
    props.signinUser(email, password, props.history);
  };

  useEffect(() => {
    if (props.error) {
      setErrorMsg('Hmm, log-in failed. Try again.');
    }
  }, [props.error]);

  return (
    <div className="sign-in">
      <h1>sign in</h1>
      <h2>email</h2>
      <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email" />
      <h2>password</h2>
      <input value={password} type="password" onChange={(e) => setPassword(e.target.value)} placeholder="password" />
      <button type="button" onClick={submit}>sign in</button>
      <NavLink exact to="/signup" className="fake-button">No Account Yet? Sign Up</NavLink>
      <p className="error-msg">{errorMsg}</p>
    </div>
  );
}

const mapStateToProps = (state) => ({
  error: state.auth.error,
});

export default withRouter(connect(mapStateToProps, { signinUser })(SignIn));
